import { FormControl, Grid, MenuItem, Paper, Select } from "@mui/material";
import PaperButton from "components/buttons/PaperButton";
import StackChart from "components/charts/StackChart";
import { ERR_NETWORK } from "constants/messages";
import { getCurrentYearNum } from "lib/date";
import { toNumber } from "lib/math";
import { getBoxesWithYear } from "models/weeklySlotsModel";
import { useSnackbar } from "notistack";
import { useEffect, useMemo, useState } from "react";

export default function SalesBarChart() {
  const { enqueueSnackbar } = useSnackbar();
  const [option, setOption] = useState("box");
  const [selYear, setSelYear] = useState(getCurrentYearNum());
  const [data, setData] = useState([]);

  const errorAction = (res, err) => {
    if (!res && err?.message) {
      enqueueSnackbar(err?.message, { variant: "warning" });
    } else {
      enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
    }
  };

  const years = useMemo(() => {
    const cur_year = getCurrentYearNum();
    return Array.from(Array(4).keys()).reduce(
      (ret, cur) => [...ret, cur_year - cur],
      [cur_year + 1]
    );
  }, []);

  const loadData = () => {
    getBoxesWithYear({
      data: { year: selYear },
      onFinish: (res, err) => {
        if (res === false) {
          errorAction(res, err);
          return;
        }
        setData(res);
      },
    });
  };

  useEffect(() => {
    loadData();
    //eslint-disable-next-line
  }, [selYear]);

  return (
    <div className="mb-5">
      <Paper className="p-5">
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Grid container alignItems="center">
              <Grid item>
                <PaperButton
                  variant="text"
                  color={option === "box" ? "secondary" : "dark-blue"}
                  onClick={() => setOption("box")}
                >
                  <span className={option === "box" ? "underline" : ""}>
                    Boxes
                  </span>
                </PaperButton>
              </Grid>
              <Grid className="px-2" item>
                <PaperButton
                  variant="text"
                  color={option === "pie" ? "secondary" : "dark-blue"}
                  onClick={() => setOption("pie")}
                >
                  <span className={option === "pie" ? "underline" : ""}>
                    Pies
                  </span>
                </PaperButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container alignItems="center">
              <Grid item>
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={toNumber(selYear)}
                    onChange={(e) => setSelYear(e.target.value)}
                  >
                    {years?.map((item, itemIndex) => (
                      <MenuItem value={item} key={itemIndex}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <StackChart
              height={450}
              data={data}
              yField={option === "box" ? "boxes" : "pies"}
            />
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}
